export default "__VITE_ASSET__BIe5zPdk__"